import { combineReducers } from "redux";

import dlsMaterials from "./dlsMaterials";
import isEditMode from "./isEditMode";
import materialPool from "./materialPool";
import materials from "./materials";
import isDLSMaterialsLoading from "./isDLSMaterialsLoading";

const reducer = combineReducers({
  dlsMaterials,
  isEditMode,
  materialPool,
  materials,
  isDLSMaterialsLoading
});

export default reducer;
